import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../ui/button';
import {
  LayoutDashboard,
  List,
  Package,
  Settings,
  Users,
} from 'lucide-react';

const NAV_ITEMS = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard, testId: 'nav-dashboard' },
  { to: '/admin/applications', label: 'Applications', icon: List, testId: 'nav-applications' },
  { to: '/admin/stores', label: 'Stores & Procurement', icon: Package, testId: 'nav-stores' },
];

const SUPER_ADMIN_ITEMS = [
  {
    to: '/admin/authorizations',
    label: 'Authorisations',
    icon: Settings,
    testId: 'nav-authorizations',
  },
  { to: '/admin/users', label: 'User Management', icon: Users, testId: 'nav-users' },
];

function isActive(pathname, to) {
  if (to === '/admin/applications') {
    return pathname.startsWith('/admin/applications');
  }
  return pathname === to || pathname.startsWith(`${to}/`);
}

export function AdminSidebar() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const items =
    user?.role === 'super_admin' ? [...NAV_ITEMS, ...SUPER_ADMIN_ITEMS] : NAV_ITEMS;

  return (
    <aside className="w-64 bg-white border-r border-slate-200 min-h-[calc(100vh-68px)] sticky top-[68px]">
      <nav className="p-4 space-y-1">
        {items.map(({ to, label, icon: Icon, testId }) => {
          const active = isActive(pathname, to);
          return (
            <Link key={to} to={to}>
              <Button
                variant="ghost"
                className={`w-full justify-start ${active ? 'bg-slate-100' : ''}`}
                data-testid={testId}
              >
                <Icon className="h-4 w-4 mr-3" />
                {label}
              </Button>
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}
